import type { FormEvent } from 'react'
import { Button, FormInput } from '@/shared/components'
import { useInviteLinkRecovery } from './useInviteLinkRecovery'

export function InviteLinkRecoveryScreen() {
  const { email, errorMessage, handleEmailChange, isSubmitting, submit, successMessage } =
    useInviteLinkRecovery()

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    void submit()
  }

  return (
    <div className="bg-white px-4 py-16 md:py-24">
      <div className="mx-auto flex min-h-[40vh] max-w-md animate-fade-in-up items-center">
        <div className="w-full">
        <div className="mb-8 text-center">
          <h1 className="modal-heading__title text-center">You are not logged in</h1>
          <p className="modal-heading__subtitle mt-2 text-center">
            Please click the link you received in the invitation email or enter your email to
            receive the invite link again.
          </p>
        </div>

        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <FormInput
            label="Email"
            placeholder="Email"
            type="email"
            value={email}
            error={Boolean(errorMessage)}
            onChange={handleEmailChange}
          />

          {errorMessage ? <p className="-mt-2 text-sm text-red-500">{errorMessage}</p> : null}
          {successMessage ? <p className="-mt-2 text-sm text-green-600">{successMessage}</p> : null}

          <Button type="submit" fullWidth loading={isSubmitting}>
            Resend Invite link
          </Button>
        </form>
        </div>
      </div>
    </div>
  )
}
